export default __webpack_public_path__ + "static/media/SpaceMono-Regular.ab58bedc.ttf";